import BaseForm from '@js/forms/base-form'

class FormSurvey extends BaseForm {
  static getDataTemplate () {
    return {
      name: '',
      file: null,
    };
  }
  constructor () {
    super();
  }
  getPostPayload () {
    const formData = new FormData();
    formData.append('name', this.data.name);
    formData.append('surveyFile', this.data.file);
    return formData;
  }
}

export {
  FormSurvey,
};
